<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false"  :modal-append-to-body="false"
            v-loading="loading"
            element-loading-background = "rgba(255, 255,255,0.7)"
            element-loading-text = "修改中..."
            :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                    <el-form-item   prop="title" label="指标名称">
                        <el-input v-model="form.title" maxlength="50" placeholder="自定义4~10个汉字" style="width:200px;"></el-input>
                    </el-form-item>
                    <el-form-item   prop="evaluateTypeId" label="五育类型">
                        <el-select v-model="form.evaluateTypeId"  clearable placeholder="请选择" style="width:200px;">
                            <el-option
                                v-for="item in evaluateTypes"
                                :key="item.id"
                                :label="item.evaluateTypeName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item   prop="score" label="初始分数">
                        <el-input v-model="form.score" max="100" type="number" style="width:200px;"></el-input>
                    </el-form-item>
                    <el-form-item   prop="useScope" label="使用范围">
                        <el-select v-model="form.useScope"  clearable placeholder="请选择" style="width:200px;">
                            <el-option
                                v-for="item in useScopes"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item   prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" max="999" type="number" style="width:200px;"></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                form:{
                    id:"",
                    userId:"",
                    classId:"",
                    evaluateTypeId:"",
                    useScope:"",
                    title:"",
                    type:"",
                    score:-1,
                    orderNum:1,
                },
                evaluateTypes:[],
                useScopes:[{
                    id:1,
                    label:"当前班级"
                },{
                    id:2,
                    label:"我的班级"
                }],
                rules: {
                    title: [
                        { required: true, message: '请输入指标名称', trigger: 'blur' }
                    ],
                    evaluateTypeId: [
                        { required: true, message: '请选择五育类型', trigger: 'blur' }
                    ],
                    useScope: [
                        { required: true, message: '请选择使用范围', trigger: 'blur' }
                    ],
                    score: [
                        { required: true, message: '请输入初始分数', trigger: 'blur' }
                    ],
                    orderNum: [
                        { required: true, message: '请输入排序号', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                let userId = sessionStorage.getItem('userId');
                let classId = sessionStorage.getItem('classId');

                this.form.userId=userId;
                this.form.classId = classId;

                this.form.id=data.id;
                this.form.evaluateTypeId=data.evaluateTypeId;
                this.form.useScope = data.useScope;
                this.form.title=data.title;
                this.form.type=data.type;
                this.form.score=data.score;
                this.form.orderNum=data.orderNum;

                // 获五育类型
                this.getEvaluateType();
                // 初始排序号
                this.form.orderNum =data.orderNum;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // 获取五育评价类型
            getEvaluateType(){
                let url= this.setClassBindEvaluateindexEvaluateTypeListUrl;
                let data = {
                    userId:this.form.userId,
                };
                this.evaluateTypes= [];
                this.apiPost(url, data).then((res) => {
                    console.log(res);
                    if(res.status === 200){
                        this.evaluateTypes=res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                }, (err) => {
                    console.log(err);
                });
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.setClassBindEvaluateindexUpdateUrl;
                        let data = {
                            id:this.form.id,
                            classId:this.form.classId,
                            evaluateTypeId:this.form.evaluateTypeId,
                            useScope:this.form.useScope,
                            title:this.form.title,
                            type:this.form.type,
                            score:this.form.score,
                            orderNum:this.form.orderNum,
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.loading=true;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/set/classroomtime/index/update.vue